import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-[var(--border-light)]">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_b7cbf998-dd1d-4ed5-b0d9-0fe2f43a4ea9/artifacts/i9q1ku9h_Logo%20ReDesign.png" 
              alt="Infiniti Health" 
              className="h-10 w-auto mb-4"
            />
            <p className="body-small text-[var(--text-secondary)] mb-4">
              Healthcare support company helping hospitals and patients manage treatment access and insurance claims efficiently.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="body-small text-[var(--text-secondary)] hover:text-[var(--brand-blue)] transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="body-small text-[var(--text-secondary)] hover:text-[var(--brand-blue)] transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="body-small text-[var(--text-secondary)] hover:text-[var(--brand-blue)] transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="heading-3 mb-4">Contact Information</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[var(--brand-green)] flex-shrink-0 mt-1" />
                <p className="body-small text-[var(--text-secondary)]">
                  #3 1st Floor, Opp Sahana Vidya Mandir<br />
                  Naganathapura, Bangalore - 560100
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[var(--brand-green)] flex-shrink-0" />
                <a href="tel:7676620620" className="body-small text-[var(--text-secondary)] hover:text-[var(--brand-blue)] transition-colors">
                  7676620620
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[var(--brand-green)] flex-shrink-0" />
                <a href="mailto:info@infiniti-health.com" className="body-small text-[var(--text-secondary)] hover:text-[var(--brand-blue)] transition-colors">
                  info@infiniti-health.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[var(--border-light)] mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4">
            <p className="body-small text-[var(--text-muted)]">
              © {new Date().getFullYear()} Infiniti Health. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="body-small text-[var(--text-muted)] hover:text-[var(--brand-blue)] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-use" className="body-small text-[var(--text-muted)] hover:text-[var(--brand-blue)] transition-colors">
                Terms of Use
              </Link>
            </div>
          </div>
          <div className="text-center">
            <p className="body-small text-[var(--text-muted)] text-xs">
              Copyright © {new Date().getFullYear()} Infiniti Health. All content, logos, and materials are the property of Infiniti Health. 
              Unauthorized use, reproduction, or distribution is strictly prohibited.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
